var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMediaVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-media-videos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-library-V2",
    transform: "translate(-19.000000, -291.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 0.782608696
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-media-videos",
    transform: "translate(20.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 0,
    y: 0,
    width: 18,
    height: 15.6521739
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 1.95652174,
    x2: 18,
    y2: 1.95652174,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.30434783,
    y1: 1.95652174,
    x2: 4.30434783,
    y2: 0,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.95652174,
    y1: 1.95652174,
    x2: 1.95652174,
    y2: 0,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.65217391,
    y1: 1.95652174,
    x2: 6.65217391,
    y2: 0,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 1.95652174,
    x2: 9,
    y2: 0,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3478261,
    y1: 1.95652174,
    x2: 11.3478261,
    y2: 0,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.6956522,
    y1: 1.95652174,
    x2: 13.6956522,
    y2: 0,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.0434783,
    y1: 1.95652174,
    x2: 16.0434783,
    y2: 0,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 13.6956522,
    x2: 0,
    y2: 13.6956522,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.6956522,
    y1: 13.6956522,
    x2: 13.6956522,
    y2: 15.6521739,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.0434783,
    y1: 13.6956522,
    x2: 16.0434783,
    y2: 15.6521739,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3478261,
    y1: 13.6956522,
    x2: 11.3478261,
    y2: 15.6521739,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 13.6956522,
    x2: 9,
    y2: 15.6521739,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.65217391,
    y1: 13.6956522,
    x2: 6.65217391,
    y2: 15.6521739,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.30434783,
    y1: 13.6956522,
    x2: 4.30434783,
    y2: 15.6521739,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.95652174,
    y1: 13.6956522,
    x2: 1.95652174,
    y2: 15.6521739,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "7.43478261 5.47826087 7.43478261 10.173913 11.3478261 7.82608696"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMediaVideos);
export default __webpack_public_path__ + "static/media/icon-media-videos.e495725a1cbd512806fabe8852b1ecbe.svg";
export { ForwardRef as ReactComponent };